import PageLayout from '@hellodarwin/app-core/lib/layouts/page-layout';
import PdfViewer from '@hellodarwin/app-features/lib/features/pdfViewer/pdf-viewer';
import type { AssetDownloadResponse } from '@hellodarwin/core/lib/features/entities/assets-entities';
import { antdNotification } from '@hellodarwin/core/lib/features/providers/antd-app-provider';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../app/app-hooks';
import { downloadAsset } from '../../features/api/slices/assets-slice';
import { useNewClientApi } from '../../features/api/use-client-api';

const GamePlanPdfViewerPage = () => {
  const api = useNewClientApi();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { assetId } = useParams<{ assetId: string }>();
  const { t } = useTranslations();
  const [assetResponse, setAssetResponse] =
    useState<AssetDownloadResponse | null>(null);

  const handleDownload = useCallback(() => {
    if (!assetId) return;
    dispatch(downloadAsset({ api, asset_id: assetId }))
      .unwrap()
      .then(({ link }) => window.open(link, 'download'))
      .catch((error) => console.error(error));
  }, [api, assetId, dispatch]);

  useEffect(() => {
    if (!assetId) return;
    dispatch(downloadAsset({ api, asset_id: assetId }))
      .unwrap()
      .then(setAssetResponse)
      .catch((error) => {
        console.error(error);
        antdNotification.error({
          message: t('errors|pdf_error'),
        });
        navigate('/game-plan');
      });
  }, [api, assetId, dispatch, navigate, t]);

  return (
    <PageLayout
      app="client"
      title={assetResponse?.asset.display_name ?? t('game-plan-cycles|title')}
      breadcrumbs={[
        {
          breadcrumbName: t('game-plan-cycles|title'),
          path: '/game-plan',
        },
        {
          breadcrumbName:
            assetResponse?.asset.display_name ??
            t('game-plan-cycles|cycle_unassigned'),
        },
      ]}
    >
      {assetResponse && assetId && (
        <PdfViewer
          pdfFile={assetResponse.link}
          fitContainer
          onDownload={handleDownload}
          onError={() => navigate('/game-plan')}
        />
      )}
    </PageLayout>
  );
};

export default GamePlanPdfViewerPage;
